module.exports = __webpack_public_path__ + "img/vertical_bar_chart.96e555be.svg";